// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app__content":"App_app__content__Ry-qx","app__loader":"App_app__loader__0SeZB"};